module.exports = __webpack_public_path__ + "img/1.27_Russian_road_sign.b9722090.svg";